import { ChangeDetectionStrategy, Component, ElementRef, Renderer2 } from '@angular/core';
import { JaneDoeAddressCardStackContentViewModel } from './jane-doe-address-card-stack-content-view-model';
import { PrintCardContentComponent } from '../../shared/print-card-content.component';

@Component({
  selector: 'app-jane-doe-address-card-stack-content',
  templateUrl: './jane-doe-address-card-stack-content.component.html',
  styleUrls: ['./jane-doe-address-card-stack-content.component.scss'],
  providers: [JaneDoeAddressCardStackContentViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class JaneDoeAddressCardStackContentComponent extends PrintCardContentComponent {
  constructor(
    public override viewModel: JaneDoeAddressCardStackContentViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }
}
